import { render, staticRenderFns } from "./_client.vue?vue&type=template&id=4dac93b8"
import script from "./_client.vue?vue&type=script&lang=js"
export * from "./_client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports